<template lang="html">
  <div>
    <NavBar />
    <UserLoader />
    <div v-if="this.$store.state.userLoaded">
      <button @click="newShow">create new show</button>
    </div>
    <ShowList v-if="this.$store.state.userLoaded" />
  </div>
</template>

<script>
import UserLoader from "@/components/Editor/loaders/UserLoader";
import ShowList from "@/components/Editor/ShowList";
import NavBar from "@/components/Editor/NavBar";
export default {
  name: "List",
  components: {
    UserLoader,
    ShowList,
    NavBar
  },
  methods: {
    newShow() {
      this.$store.dispatch("newShow");
    }
  }
};
</script>

<style lang="css" scoped></style>
